import { useEffect, useState } from 'react'
import { Nav } from '../components/Nav'
import { Hero } from '../components/Hero'
import { Identita } from '../components/Identita'
import { Singoli } from '../components/Singoli'
import { Videos } from '../components/Videos'
import { Gallery } from '../components/Gallery'
import { Repertorio } from '../components/Repertorio'
import { DateLive } from '../components/DateLive'
import { Contatti } from '../components/Contatti'
import { fetchContent } from '../lib/api'
import { useLang } from '../lib/lang'
import type { ContentBundle } from '../lib/types'

function LoadingScreen() {
  return (
    <div style={{
      minHeight: '100vh', background: 'var(--ink)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      color: 'var(--fg-inverse-muted)',
      fontFamily: 'var(--font-body)', fontSize: 12,
      letterSpacing: '0.24em', textTransform: 'uppercase',
    }}>…</div>
  )
}

function ErrorScreen({ error }: { error: string }) {
  return (
    <div style={{
      minHeight: '100vh', background: 'var(--ink)',
      color: 'var(--fg-inverse)', padding: '120px 48px',
      fontFamily: 'var(--font-body)',
    }}>
      <p style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 22 }}>
        Non siamo riusciti a caricare i contenuti.
      </p>
      <pre style={{ marginTop: 24, color: 'var(--fg-inverse-muted)', fontSize: 12 }}>{error}</pre>
    </div>
  )
}

export function HomePage() {
  const { lang } = useLang()
  const [bundle, setBundle] = useState<ContentBundle | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setBundle(null)
    setError(null)
    fetchContent(lang)
      .then((b) => { if (!cancelled) setBundle(b) })
      .catch((e) => { if (!cancelled) setError(String(e)) })
    return () => { cancelled = true }
  }, [lang])

  useEffect(() => {
    if (!bundle) return
    document.title = bundle.site.meta_title
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) metaDesc.setAttribute('content', bundle.site.meta_description)
    document.documentElement.lang = lang
  }, [bundle, lang])

  if (error) return <ErrorScreen error={error} />
  if (!bundle) return <LoadingScreen />

  const s = bundle.sections
  const navVisible = {
    progetto: s.identita && bundle.identita.length > 0,
    singoli:  s.singoli  && bundle.singoli.length  > 0,
    videos:   s.videos   && bundle.videos.length   > 0,
    live:     s.date_live,
    contatti: s.contatti,
  }
  return (
    <>
      <Nav visible={navVisible} />
      {s.hero       && <Hero hero={bundle.hero} />}
      {s.identita   && <Identita blocks={bundle.identita} />}
      {s.singoli    && <Singoli items={bundle.singoli} />}
      {s.videos     && <Videos items={bundle.videos} />}
      {s.gallery    && <Gallery images={bundle.gallery} />}
      {s.repertorio && <Repertorio items={bundle.repertorio} />}
      {s.date_live  && <DateLive items={bundle.date_live} />}
      {s.contatti   && <Contatti contatti={bundle.contatti} />}
    </>
  )
}
